 import find from 'lodash/find';
 
 export class PrivacyPolicyService {
     constructor($resource, ApiService) {
         'ngInject';

        this.$resource = $resource;
		this.apiService = ApiService;
        
        this.privacyPolicyResourceUrl = this.apiService.getResourceUrl('cms/menus/PrivacyPolicy');
        this.editPrivacyPolicyResourceUrl = this.apiService.getResourceUrl('cms/privacy-policy');

        this.privacyPolicyResource = this.$resource(this.privacyPolicyResourceUrl);
        this.editPrivacyPolicyResource = this.$resource(this.editPrivacyPolicyResourceUrl,null,{
            update: {
                method: 'PUT'
            }
        });
     }

    _getContentDetails(value) {
		return {
			id: value.content_id,
			description: value.description,
			images: this._getContentImagesObject(value.images) || [],
			videos: value.videos || []
		}
	}

	_getContentImagesObject(values) {
		return values ? values.map(({uuid}) => ({uuid, status:-1})) : [];
	}

	_setContentDetails(value) {
		return {
			description: value.description,
			images: value.images || [],
			videos: value.videos || []
		}
	}

     /************
      * To get Privacy & Policy
      ***************/
      getPrivacyPolicyDetails({data}) {
          return { menuContentDetails: this._getContentDetails(find(data.content, ['name', 'PrivacyPolicy']).values[0]) }
      }

      /*************
       * To Update Privacy & Policy
       *****************/
      editPrivacyPolicy(details) {
        const promise = this.editPrivacyPolicyResource.update(this._setContentDetails(details)).$promise;

        return promise
            .then(details => details)
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            });
      }
 }


// WEBPACK FOOTER //
// ./src/app/components/privacy-policy/privacy-policy.service.js